/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import type AppService from 'embercom/services/app-service';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import safeWindowOpen from 'embercom/lib/safe-window-open';
import type ExternalContent from 'embercom/models/external-content';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import { objectNames } from 'embercom/models/data/matching-system/matching-constants';

interface Args {
  activeContent: ExternalContent;
  editActiveContent: () => void;
  showSidePanel: boolean;
  toggleSidePanel: () => void;
  onClose?: () => void;
  showDeleteButton?: boolean;
  showEditButton?: boolean;
  showViewInKnowledgeButton?: boolean;
}

export default class Header extends Component<Args> {
  @service declare router: RouterService;
  @service declare appService: AppService;

  get showDeleteButton() {
    return this.args.showDeleteButton ?? true;
  }

  get showEditButton() {
    return this.args.showEditButton ?? true;
  }

  get showViewInKnowledgeButton() {
    return this.args.showViewInKnowledgeButton ?? false;
  }

  @action
  viewInKnowledge() {
    safeWindowOpen(
      this.router.urlFor(
        'apps.app.knowledge-hub.view',
        objectNames[this.args.activeContent.entityType],
        this.args.activeContent.entityId,
      ),
      '_blank',
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::Snippet::View::Header': typeof Header;
    'knowledge-hub/content-editor/snippet/view/header': typeof Header;
  }
}
